import { render, staticRenderFns } from "./MfaChallenge.vue?vue&type=template&id=6957f87e&scoped=true"
import script from "./MfaChallenge.vue?vue&type=script&lang=js"
export * from "./MfaChallenge.vue?vue&type=script&lang=js"
import style0 from "./MfaChallenge.vue?vue&type=style&index=0&id=6957f87e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6957f87e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6957f87e')) {
      api.createRecord('6957f87e', component.options)
    } else {
      api.reload('6957f87e', component.options)
    }
    module.hot.accept("./MfaChallenge.vue?vue&type=template&id=6957f87e&scoped=true", function () {
      api.rerender('6957f87e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/MfaChallenge.vue"
export default component.exports